exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-49816454]{position:absolute}p[data-v-49816454]{background-color:#404040;border-radius:10px;color:#cecece;padding:6%;font-size:12px}.review[data-v-49816454]{opacity:0;transition:.2s}.show .review[data-v-49816454]{opacity:1;transition:1s;z-index:999}.map-marker[data-v-49816454]{fill:#27dafe;opacity:.4;transform-origin:50% bottom;transform:scale(.5);width:46.8px;height:62.4px;pointer-events:auto}.show .map-marker[data-v-49816454]{opacity:1;transition:1s;transform-origin:50% bottom;transform:scale(1)}", ""]);

// exports
